const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export function parseYouTubeVideoId(input) {
  const value = String(input || "").trim();
  if (VIDEO_ID_PATTERN.test(value)) return value;
  let url;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (!['http:', 'https:'].includes(url.protocol)) return null;
  const host = url.hostname.toLowerCase().replace(/^(www\.|m\.|music\.)/, "");
  let candidate = null;
  if (host === "youtu.be") candidate = url.pathname.split("/").filter(Boolean)[0];
  if (["youtube.com", "youtube-nocookie.com"].includes(host)) {
    const parts = url.pathname.split("/").filter(Boolean);
    candidate = url.pathname === "/watch" ? url.searchParams.get("v") : (["embed", "shorts", "live"].includes(parts[0]) ? parts[1] : null);
  }
  return VIDEO_ID_PATTERN.test(candidate || "") ? candidate : null;
}
